import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { ContentFooterAddon } from './components/ContentFooterAddon';
import { techdocsExtensionPlugin } from '../../../plugin';

export const ContentFooter = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'ContentFooter',
    location: TechDocsAddonLocations.Content,
    component: ContentFooterAddon,
  }),
);
